import React, { useState } from 'react';
import { Form, Button, InputGroup, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';

import { registerApi } from '@/lib/api/Auth';
import { redirectUser } from '@/lib/api/Redirect';


import 'bootstrap/dist/css/bootstrap.min.css';
import HTopbar from '../../hooks/HomeTopBar';

const RegisterPage = ({ accountType }) => {
  const [form, setForm] = useState({
    email: '',
    full_name: '',
    password: '',
    rePassword: '',
    birthdate: null,
    gender: '',
    weight: '',
    height: '',
    account_type: accountType,
  });
  const [loading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleDateChange = (date) => setForm({ ...form, birthdate: date });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const start = Date.now();

    // Passwords match check
    if (form.password !== form.rePassword) {
      setLoading(false);
      return alert("Passwords don't match");
    }

    if (form.height && (form.height < 1 || form.height > 12)) {
      setLoading(false);
      return alert("Height must be between 1 and 12 ft");
    }


    // Birthdate and age check (only for non-organizers)
    if (accountType !== 'sport_organizer') {
      if (!form.birthdate) {
        setLoading(false);
        return alert('Please select your birthdate');
      }

      const today = new Date();
      const birthDate = new Date(form.birthdate);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      if (age < 18) {
        setLoading(false);
        return alert('You must be at least 18 years old to register');
      }
    }

    const data = {
      email: form.email,
      full_name: form.full_name,
      password: form.password,
      birthdate: form.birthdate ? format(form.birthdate, 'yyyy-MM-dd') : null,

      gender: form.gender || null,
      weight: form.weight ? parseFloat(form.weight) : null,
      height: form.height ? parseFloat(form.height) : null,
      account_type: form.account_type,
    };

    const formData = new FormData();
    formData.append('data', JSON.stringify(data));
    const storedData = JSON.parse(formData.get('data'));



    try {
      await registerApi(formData);
      const user = await redirectUser();
      navigate('/security-setup', { state: { userId: user.id, userType: user.account_type } });
    } catch (err) {

      alert(err.response.data.detail);

    } finally {
      const elapsed = Date.now() - start;
      const remaining = 2000 - elapsed;
      if (remaining > 0) {
        setTimeout(() => setLoading(false), remaining);
      } else {
        setLoading(false);
      }
    }
  };



  return (
    <>
      <HTopbar />


      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          minHeight: '100vh',
          paddingTop: '50px',
          width: '100%',
          backgroundImage: 'url(/images/auth/register.jpg)',
          backgroundSize: 'cover',       // cover the entire div
          backgroundPosition: 'center',   // center the image
          backgroundRepeat: 'no-repeat',  // prevent tiling
        }}
      >



        <div
          className="p-3 shadow rounded"
          style={{
            width: '100%',
            maxWidth: '700px',
            backgroundColor: '#FFFFFF', // solid background
          }}
        >

          <div className="text-center mb-3">


            <h1
              style={{
                fontSize: '80px',       // bigger than default
                fontWeight: 900,        // extra-bold / thick
                letterSpacing: '2px',
                margin: 0,
              }}
            >
              MATCH
            </h1>
            <h2
              style={{
                fontSize: '60px',       // slightly smaller but still prominent
                fontWeight: 800,        // slightly lighter than MATCH for contrast
                letterSpacing: '1px',
                margin: 0,
              }}
            >
              UP
            </h2>

            <p className="mt-1">Start your sport journey with MatchUp</p>
          </div>

          <Form onSubmit={handleSubmit}>
            <Row className="g-2">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Email</Form.Label>
                  <InputGroup size="sm">
                    <InputGroup.Text>@</InputGroup.Text>
                    <Form.Control
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                  </InputGroup>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>
                    {accountType === 'sport_organizer' ? 'Organization' : 'Full Name'}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="full_name"
                    value={form.full_name}
                    onChange={handleChange}
                    placeholder={accountType === 'sport_organizer' ? 'Organization Name' : 'Your Name'}
                    required
                    size="sm"
                  />
                </Form.Group>
              </Col>

              {accountType !== 'sport_organizer' && (
                <>
                  <Col md={6}>
                    <Form.Label>Birthdate</Form.Label>

                    <Form.Group>

                      <DatePicker
                        selected={form.birthdate ? new Date(form.birthdate) : null}
                        onChange={handleDateChange}
                        dateFormat="yyyy-MM-dd"
                        minDate={new Date(1900, 0, 1)}
                        maxDate={new Date()}
                        showYearDropdown
                        scrollableYearDropdown
                        yearDropdownItemNumber={150}
                        placeholderText="YYYY-MM-DD"
                        className="form-control form-control-sm"
                      />
                    </Form.Group>
                  </Col>


                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Gender</Form.Label>
                      <Form.Select name="gender" value={form.gender} onChange={handleChange} size="sm">
                        <option value="">Select Gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="other">Other</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Weight (kg)</Form.Label>
                      <Form.Control
                        type="any"
                        name="weight"
                        value={form.weight}
                        onChange={handleChange}
                        min="0"
                        size="sm"
                      />
                    </Form.Group>
                  </Col>


                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Height (ft)</Form.Label>
                      <Form.Control
                        type="any"
                        name="height"
                        value={form.height}
                        onChange={handleChange}
                        min="0"
                        max="12"
                        size="sm"
                      />
                    </Form.Group>
                  </Col>



                </>
              )}

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Password</Form.Label>
                  <InputGroup size="sm">
                    <InputGroup.Text>🔒</InputGroup.Text>
                    <Form.Control
                      type={showPassword ? 'text' : 'password'}
                      name="password"
                      value={form.password}
                      onChange={handleChange}
                      required
                      size="sm"
                    />
                    <Button variant="outline-secondary" size="sm" onClick={() => setShowPassword(!showPassword)}>👁️</Button>
                  </InputGroup>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Re-enter Password</Form.Label>
                  <InputGroup size="sm">
                    <InputGroup.Text>🔒</InputGroup.Text>
                    <Form.Control
                      type={showRePassword ? 'text' : 'password'}
                      name="rePassword"
                      value={form.rePassword}
                      onChange={handleChange}
                      required
                      size="sm"
                    />
                    <Button variant="outline-secondary" size="sm" onClick={() => setShowRePassword(!showRePassword)}>👁️</Button>
                  </InputGroup>
                </Form.Group>
              </Col>

              <Col xs={12} className="mt-2">
                <Button type="submit" variant="dark" className="w-100" disabled={loading}>
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Registering...
                    </>
                  ) : (
                    'Register'
                  )}
                </Button>

              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </>
  );
};

export default RegisterPage;
